import { Box, BoxProps } from "@mui/material";
import React from "react";
import { tabStyleMap, tabContentStyles, tabIndicatorStyles } from "./constants";

export type TabVariant = "primary" | "secondary";

export interface TabProps extends Omit<BoxProps, "variant"> {
  label?: string;
  icon?: React.ReactNode;
  variant?: TabVariant;
  selected?: boolean;
  hovered?: boolean;
  pressed?: boolean;
  onClick?: () => void;
}

export const Tab: React.FC<TabProps> = ({
  label,
  icon,
  variant = "primary",
  selected = false,
  hovered = false,
  pressed = false,
  onClick,
  ...props
}) => {
  const tabStyles = tabStyleMap[variant]({ selected, hasIcon: !!icon });

  return (
    <Box sx={tabStyles} onClick={onClick} {...props}>
      {variant === "primary" ? (
        <>
          <Box sx={tabContentStyles(variant, !!icon)}>
            {icon && (
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                {icon}
              </Box>
            )}
            {label && <Box component="span">{label}</Box>}
          </Box>
          <Box sx={tabIndicatorStyles(variant, selected)} />
        </>
      ) : (
        <>
          {icon && (
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              {icon}
            </Box>
          )}
          {label && <Box component="span">{label}</Box>}
          <Box sx={tabIndicatorStyles(variant, selected)} />
        </>
      )}
    </Box>
  );
};

export default Tab;
